import axios, { AxiosResponse } from 'axios';

import { FetchSyncPayload, SyncActionPayload, SyncResponse } from './sync.state';

import Config from 'config';

class SyncService {
  async createSync(payload: SyncActionPayload): Promise<AxiosResponse<SyncResponse>> {
    return await axios.post<SyncResponse>(`${Config.FEEDER_SERVER}/v2/data/sync`, payload);
  }

  async fetchSyncStatuses(
    payload: FetchSyncPayload,
  ): Promise<PromiseSettledResult<AxiosResponse<{ status: string; result: SyncResponse }>>[]> {
    const { connections, syncType, dataType } = payload;
    let addedQuery = '';
    if (syncType) {
      addedQuery += `&syncType=${syncType}`;
    }
    if (dataType) {
      addedQuery += `&dataType=${dataType}`;
    }
    const calls = connections.map(async (connectionUuid) => {
      return await axios.get(
        `${Config.FEEDER_SERVER}/v2/data/syncInfo?connectionUuid=${connectionUuid}&${addedQuery}`,
      );
    });
    return await Promise.allSettled(calls);
  }
}

export default new SyncService();
